import React from 'react';
import SvgOverviewIcon from '../icons/svgOverviewIcon';
import SvgRegisterIcon from '../icons/svgRegisterIcon';
import SvgSessionsIcon from '../icons/svgSessionsIcon';
import SvgPeopleIcon from '../icons/svgPeopleIcon';
import SvgVirtualIcon from '../icons/svgVirtualIcon';
import SvgMeetingsIcon from '../icons/svgMeetingsIcon';
import SvgLoungeIcon from '../icons/svgLoungeIcon';
import { Airplay, Database } from 'react-feather';
import SvgFileLogsIcon from '../icons/svgFileLogsIcon';
import SvgRecordingIcon from '../icons/svgRecordingIcon';
import SvgSettingsIcon from '../icons/svgSettingsIcon';
import SvgBrandingIcon from '../icons/svgBrandingIcon';
import SvgAnalyticsIcon from '../icons/svgAnalyticsIcon';
import SvgEngagementIcon from '../icons/svgEngagementIcon';
import SvgRoomsIcon from '../icons/svgRoomsIcon';
import SvgEmailIcon from '../icons/svgEmailIcon';
import SvgIntegrationIcon from '../icons/svgIntegrationIcon';
import SvgLandingPageIcon from '../icons/svgLandingPageIcon';

export const navLinks = [
  {
    id: 0,
    name: 'Overview',
    icon: <SvgOverviewIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/',
  },
  {
    id: 4,
    name: 'People',
    icon: <SvgPeopleIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/people',
  },
  {
    id: 2,
    name: 'Registration',
    icon: <SvgRegisterIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/registration',
    isSubMenuOpen: false,
    subMenu: [
      {
        name: 'Tickets',
        hasEventIdAndOrganiserId: true,
        url: '/registration/ticket',
      },
      {
        name: 'Discounts',
        hasEventIdAndOrganiserId: true,
        url: '/registration/discount',
        communityVersion: 2,
      },
      {
        name: 'Orders',
        hasEventIdAndOrganiserId: true,
        url: '/registration/order',
      },
      {
        name: 'UTM code',
        hasEventIdAndOrganiserId: true,
        url: '/registration/utm',
        communityVersion: 2,
      },
    ],
    isShow: true,
  },
  {
    id: 18,
    name: 'Landing',
    icon: <SvgLandingPageIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/registration/landing-page',
    communityVersion: 2,
  },

  {
    id: 3,
    name: 'Sessions',
    icon: <SvgSessionsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/sessions',
    subUrl: '/session',
  },
  // {
  //   id: 19,
  //   name: 'Lobby',
  //   icon: <SvgLoungeIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/virtual-booth',
  //   communityVersion: 2,
  //   subMenu: [
  //     {
  //       id: 5,
  //       name: 'Booths',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/virtual-booth',
  //       subUrl: '/virtual-detail',
  //     },
  //     {
  //       id: 6,
  //       name: 'Meetings',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/meetings',
  //     },
  //     {
  //       id: 7,
  //       name: 'Lounge',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/lounge',
  //       inPersonDisabledView: true,
  //     },
  //     {
  //       id: 8,
  //       name: 'Rooms',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/rooms',
  //       inPersonDisabledView: true,
  //     },
  //   ]
  // },

  {
    id: 5,
    name: 'Booths',
    icon: <SvgVirtualIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/virtual-booth',
    subUrl: '/virtual-detail',
  },
  {
    id: 6,
    name: 'Meetings',
    icon: <SvgMeetingsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/meetings',
  },
  {
    id: 7,
    name: 'Lounge',
    icon: <SvgLoungeIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/lounge',
    inPersonDisabledView: true,
  },
  {
    id: 8,
    name: 'Rooms',
    icon: <SvgRoomsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/rooms',
    inPersonDisabledView: true,
  },

  {
    id: 17,
    name: 'Emails',
    icon: <SvgEmailIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/email-builder',
  },
  {
    id: 9,
    name: 'Engagement',
    icon: <SvgEngagementIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/engagement',
    isSubMenuOpen: false,
    subMenu: [
      {
        name: 'Notifications',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/notification',
      },
      {
        name: 'Activity Feed',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/activity-feed',
      },
      {
        name: 'Leaderboard',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/leaderboard',
        inPersonDisabledView: true,
      },
      {
        name: 'Surveys',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/survey',
      },
      {
        name: 'Contest',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/contest',
      },
      {
        name: 'Quiz',
        hasEventIdAndOrganiserId: true,
        url: '/engagement/quiz',
      },
    ],
  },
  /* {
    id: 16,
    name: 'Embedded Apps',
    icon: <SvgEmbedAppsIcon height="22px" width="22px" />,
    hasEventIdAndOrganiserId: true,
    url: '/embed-apps',
    subUrl: '/embed-apps',
  }, */
  // {
  //   id: 10,
  //   name: 'Branding',
  //   icon: <SvgBrandingIcon height="18px" width="18px" />,
  //   hasEventIdAndOrganiserId: true,
  //   url: '/brand-event',
  //   isShow: true,
  //   isSubMenuOpen: false,
  //   subMenu: [
  //     {
  //       name: 'Branding',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/brand-your-events',
  //     },
  //     {
  //       name: 'Sponsored Ads',
  //       // "name": 'BRANDED SPACES',
  //       hasEventIdAndOrganiserId: true,
  //       url: '/brand-spaces',
  //     },
  //   ],
  // },
  // {
  // 	"id": 11,
  // 	"name": 'EMAIL CAMPAIGN',
  // 	"icon": <Mail size={20} strokeWidth={1} />,
  // 	"hasEventIdAndOrganiserId": true,
  // 	"url": '/email-campaign',
  // },
  {
    id: 12,
    name: 'Analytics',
    icon: <SvgAnalyticsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/analytics/people',
    subUrl: '/analytics',
  },
  {
    id: 13,
    name: 'Integrations',
    icon: <SvgIntegrationIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    url: '/integrations/connected-apps',
    // isShow: true,
    // isSubMenuOpen: false,
    // subMenu: [
    //   {
    //     name: 'Connected Apps',
    //     hasEventIdAndOrganiserId: true,
    //     url: '/integrations/connected-apps',
    //   },
    //   // {
    //   //   name: 'Embedded apps',
    //   //   // "name": 'BRANDED SPACES',
    //   //   hasEventIdAndOrganiserId: true,
    //   //   url: '/integrations/embed-apps',
    //   // },
    // ],
  },
  {
    id: 14,
    name: 'Settings',
    icon: <SvgSettingsIcon height="18px" width="18px" />,
    hasEventIdAndOrganiserId: true,
    // "url": '/settings/login-options',
    url: '/settings/general',
    keyDivider: false,
    subUrl: '/settings',
    subMenu: [
      {
        id: 20,
        name: 'Event Settings',
        hasEventIdAndOrganiserId: true,
        url: '/settings/general',
      },
      {
        name: 'Branding',
        hasEventIdAndOrganiserId: true,
        url: '/brand-your-events',
      },
      {
        name: 'Sponsored Ads',
        // "name": 'BRANDED SPACES',
        hasEventIdAndOrganiserId: true,
        url: '/brand-spaces',
      },
      {
        name: 'Embeds',
        // "name": 'BRANDED SPACES',
        hasEventIdAndOrganiserId: true,
        url: '/integrations/embed-apps',
      },
      {
        id: 15,
        name: 'Recordings',
        icon: <SvgRecordingIcon height="18px" width="18px" />,
        hasEventIdAndOrganiserId: true,
        url: '/recording',
        inPersonDisabledView: true,
      },
      {
        id: 16,
        name: 'File Logs',
        icon: <SvgFileLogsIcon height="18px" width="18px" />,
        hasEventIdAndOrganiserId: true,
        url: '/file-logs',
      },
    ],
  },
];

export const subMenu = [
  {
    name: 'Connected Apps',
    hasEventIdAndOrganiserId: true,
    url: '/integrations/connected-apps',
  },
  {
    name: 'Embedded apps',
    hasEventIdAndOrganiserId: true,
    url: '/integrations/embed-apps',
  },
];
